"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var TotalJackpot = function (_a) {
    var _b, _c, _d, _e, _f;
    var onClickJackpotHandler = _a.onClickJackpotHandler, data = _a.data;
    var t = (0, next_intl_1.useTranslations)('translation');
    var playGamesHandler = (0, react_1.useCallback)(function () {
        (0, apps_shared_1.slowScrollToElementById)('gameCollectionsAndCategories');
    }, []);
    if (!data)
        return null;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.wrapper },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, t('totalJackpot')),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.amount }, "".concat((0, apps_shared_1.getCurrencySymbol)((_c = (_b = data === null || data === void 0 ? void 0 : data.jackpot) === null || _b === void 0 ? void 0 : _b.jackpotResult) === null || _c === void 0 ? void 0 : _c.currency)).concat((_f = Math.floor(((_e = (_d = data === null || data === void 0 ? void 0 : data.jackpot) === null || _d === void 0 ? void 0 : _d.jackpotResult) === null || _e === void 0 ? void 0 : _e.currentAmount) || 0)) === null || _f === void 0 ? void 0 : _f.toLocaleString('en-US'))),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.buttonContainer },
                react_1.default.createElement(ui_components_1.FixedButton, { color: "gradient", text: "upper", onClick: onClickJackpotHandler ? onClickJackpotHandler : playGamesHandler }, t('play')))),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.backgroundGradient })));
};
exports.default = TotalJackpot;
